<template>
  <div class="admin-translate">
    <header-title title="Traducciones Bebida"></header-title>
    <v-row align="start">
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-text-field
          outlined
          dense
          label="Buscar"
          v-model="search"
          class="select-box ml-2"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <v-container fluid>
      <template>
        <div v-for="drink in paginatedData" :key="drink.id">
          <TranslateCartasPrincipales
            :data="drink"
            @saveToCollection="saveToDrinkCollection"
          ></TranslateCartasPrincipales>
        </div>
        <div class="text-center">
          <v-pagination
            v-model="pageNumber"
            :length="Math.ceil(filteredDrink.length / size)"
            circle
            @input="nextPage"
            :total-visible="6"
            color="black"
          ></v-pagination>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import Loader from "../../../components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { drinksCollection } from "@/collections/drinks";
import TranslateCartasPrincipales from "@/components/admin/translate/TranslateCartasPrincipales";
import { updateDrink } from "@/collections/drinks";

export default {
  name: "TranslateDrink",
  components: {
    HeaderTitle,
    Loader,
    TranslateCartasPrincipales
  },
  data() {
    return {
      dialogLoader: true,
      search: "",
      drinksCollection: [],
      pageNumber: 1,
      size: 2
    };
  },
  firestore() {
    return {
      drinksCollection: drinksCollection
    };
  },
  mounted() {
    setTimeout(() => {
      this.dialogLoader = false;
    }, 1000);
  },
  computed: {
    filteredDrink() {
      let _drinks = [...this.drinksCollection];
      _drinks = [
        ..._drinks.map(drink => {
          drink.ingredients.map(ingredient => {
            return (ingredient.trans = {
              en: ingredient.trans ? ingredient.trans.en : ingredient.item,
              es: ingredient.trans ? ingredient.trans.es : ingredient.item,
              it: ingredient.trans ? ingredient.trans.it : ingredient.item,
              fr: ingredient.trans ? ingredient.trans.fr : ingredient.item,
              de: ingredient.trans ? ingredient.trans.de : ingredient.item
            });
          });
          return drink;
        })
      ];
      return this.search
        ? _drinks.filter(drink =>
            drink?.name?.toLowerCase().includes(this.search?.toLowerCase())
          )
        : _drinks;
    },
    paginatedData() {
      let start = this.pageNumber * this.size - this.size;
      let end = start + this.size;
      return this.filteredDrink.slice(start, end);
    }
  },
  methods: {
    nextPage(page) {
      this.pageNumber = page;
    },
    async saveToDrinkCollection(input) {
      try {
        await updateDrink(input.id, input);
        this.showSuccessMessage("Traducciones Bebida actualizado");
      } catch (error) {
        this.setlogError(
          "save/update_drink",
          "Obtained error message in saveToDrinkCollection()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    }
  }
};
</script>
